/*!
 * Date: 2026/1/25
 * <p>
 * Copyright (c) 2026, zhaotao All Rights Reserved.
 *
 * @author zhaotao
 */

// 操作系统识别
function detectOS() {
  const platform = navigator.platform.toLowerCase();
  const ua = navigator.userAgent.toLowerCase();
  if (platform.includes("mac") || ua.includes("mac")) return "mac";
  if (platform.includes("win") || ua.includes("windows")) return "windows";
  return "unknown";
}

// Mac 架构识别
function detectMacArch() {
  if (navigator.userAgentData && navigator.userAgentData.platform === "macOS") {
    return navigator.userAgentData.architecture === "arm" ? "arm64" : "x64";
  }
  if (navigator.userAgent.match(/arm64|aarch64|apple silicon/i)) return "arm64";
  return "x64";
}

const envs = {
  baseUri: typeof window.API_BASE_URL !== 'undefined' ? window.API_BASE_URL : '/api',
  productName: typeof window.PRODUCT_NAME !== 'undefined' ? window.PRODUCT_NAME : '智慧导读',
  flavor: typeof window.PRODUCT_FLAVOR !== 'undefined' ? window.PRODUCT_FLAVOR : 'public',
  orgName: typeof window.ORG_NAME !== 'undefined' ? window.ORG_NAME: '上海半坡网络技术有限公司',
  belong: window.BELONG,
  os: detectOS(),
  arch: detectMacArch(),
  theme: typeof window.THEME !== 'undefined' ? window.THEME: 'dark',
}

export { envs }
